<div class="body">

    <div class="main-agendados">

        <mat-toolbar class="mat-elevation-z2 noselect toolbar-titulo">
            <div class="loading-shade" id="carregamento" style="visibility: hidden;">
                <mat-spinner></mat-spinner>
            </div>

            <div class="div-botao-voltar" (click)="goToHome()">
                <button mat-button class="botao-voltar">
                    <p class="p-botao-voltar">
                        <mat-icon style="padding: 5%;"> navigate_before </mat-icon>
                        Voltar
                    </p>
                </button>
            </div>

            <span class="barra-topo"></span>

            <div class="div-agendados">
                <p class="p-agendados">
                    Agendados
                </p>
            </div>

        </mat-toolbar>

        <div class="div-body">

            <mat-card class="matcard-filtrar">
                <!-- campo filtrar data -->

                <div class="content" *ngIf="!isLoadingResults">

                    <form [formGroup]="form">

                        <div class="grid grid--auto-fill">

                            <mat-form-field>
                                <mat-label>Data</mat-label>
                                <input formControlName="Data" matInput [matDatepicker]="picker">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker touchUi #picker></mat-datepicker>
                            </mat-form-field>

                        </div>

                        <div class="div-botoes">
                            <button mat-raised-button class="b-resetar-campos" type="reset" value="Reset">
                                <p class="p-resetar-campos">
                                    Resetar Campos
                                </p>
                            </button>

                            <button mat-raised-button class="b-filtrar" (click)=filtraAgendamentosPorData()
                                type="button">
                                <p class="p-filtrar">
                                    Filtrar
                                    <mat-icon style="padding: 5%;">navigate_next</mat-icon>
                                </p>
                            </button>
                        </div>

                    </form>

                </div>

            </mat-card>

            <div class="grid grid--auto-fit-lg mt-3">

                <mat-card class="mat-elevation-z8 margin-lados">

                    <div class="table">

                        <table mat-table [dataSource]="AgendadosSource" [hidden]="!true">
                            <ng-container matColumnDef="Nome">
                                <th mat-header-cell *matHeaderCellDef class="md"> <strong>Nome</strong> </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element?.nomedoCliente }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="HorarioAgendado">
                                <th mat-header-cell *matHeaderCellDef class="md"> <strong>Horário de
                                        Agendamento</strong>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element?.dataAgendamento ? element?.dataAgendamento : '-'}}
                                    {{ element?.horaAgendamento ? element?.horaAgendamento : '-'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Telefone">
                                <th mat-header-cell *matHeaderCellDef class="md"> <strong>Telefone</strong> </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element?.celular ? (element.celular | mask: ajustarMaskTelefone(element.celular))
                                    :
                                    '-'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Situacao">
                                <th mat-header-cell *matHeaderCellDef class="md"> <strong>Situação</strong> </th>
                                <td mat-cell *matCellDef="let element"
                                    (click)="goToRegistroCompleto(element.idAtendimento)" style="cursor: pointer;"
                                    [ngClass]="element?.situacao == 'Confirmado' ? 'green' : element?.situacao == 'Reagendou' ? 'red' : element?.situacao == 'Ligar' ? 'orange' : element?.situacao == 'No Show' ? 'blue' : '-'">
                                    <strong>{{ element?.situacao ? element?.situacao : '-'}}</strong>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="TipoAgendamento">
                                <th mat-header-cell *matHeaderCellDef class="md"> <strong>Tipo de Agendamento</strong>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{
                                    element?.tipoAgendamento == 3
                                    ? "Não"
                                    : element?.tipoAgendamento == 1
                                    ? "Secretaria"
                                    : "Delivery"
                                    }}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="AgendadosColumns"></tr>

                            <tr mat-row *matRowDef="let row; columns: AgendadosColumns;"></tr>

                        </table>

                    </div>

                    <div class="flex-fill"></div>
                    <mat-paginator [pageSizeOptions]="[50, 150, 100]" showFirstLastButtons></mat-paginator>

                </mat-card>
            </div>

        </div>


        <div class="div-rodape">

            <div class="div-barra-navegacao">

                <button class="b-home">
                    <mat-icon class="mat-icon-button" (click)="goToHome()"> home </mat-icon>
                </button>

                <button class="b-novo-atendimento">
                    <mat-icon class="mat-icon-button" (click)="goToNovoAtendimento()"> add </mat-icon>
                </button>

                <button class="b-pesquisar">
                    <mat-icon class="mat-icon-button" (click)="goToPesquisar()"> search </mat-icon>
                </button>

                <button class="b-agendados">
                    <mat-icon class="mat-icon-button" (click)="goToAgendados()"> calendar_today </mat-icon>
                </button>
            </div>

        </div>

    </div>

</div>